<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-identity`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M43 32a1 1 0 011 1v7c0 2.21-1.628 4-3.636 4H33a1 1 0 01-1-1v-2a1 1 0 011-1h7v-7a1 1 0 011-1h2zM7 32a1 1 0 011 1v7h7a1 1 0 011 1v2a1 1 0 01-1 1H7.636C5.628 44 4 42.21 4 40v-7a1 1 0 011-1h2zm22-8a8 8 0 018 8v4a1 1 0 01-1 1H13a1 1 0 01-1-1v-4a8 8 0 018-8h9zm0 4h-9a4 4 0 00-4 4v1h17v-1a4 4 0 00-4-4zm-5-18c3.31 0 6 2.686 6 6s-2.69 6-6 6-6-2.686-6-6 2.69-6 6-6zm0 4c-1.1 0-2 .895-2 2s.9 2 2 2 2-.895 2-2-.9-2-2-2zM40.364 4C42.372 4 44 5.79 44 8v7a1 1 0 01-1 1h-2a1 1 0 01-1-1V8h-7a1 1 0 01-1-1V5a1 1 0 011-1h7.364zM15 4a1 1 0 011 1v2a1 1 0 01-1 1H8v7a1 1 0 01-1 1H5a1 1 0 01-1-1V8c0-2.21 1.628-4 3.636-4H15z"/></svg>
</template>
<script>

export default {
  name: 'IconIdentity',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
